import styled from 'styled-components';

export const ConsentsInputWrapper = styled.div`
	margin: 20px 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	input {
		width: 100%;
		height: 40px;
		margin: 0 10px;
		padding-left: 20px;
		&:focus {
			outline: unset;
		}
	}
`;

export const Divider = styled.div`
	background-color: #ececec;
	width: 95%;
	height: 1px;
	margin: 0 auto;
	margin-bottom: 20px;
`;

export const ConsentsContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	margin: 20px;
	margin-bottom: 10px;
	max-height: 400px;
	overflow-y: auto;
	scrollbar-width: thin;
`;

export const Consent = styled.div`
	& > div > div {
		align-items: flex-start;
	}
	& > div > div > label:nth-child(1) {
		min-width: 16px;
	}
	& > div > div > label:nth-child(2) {
		text-align: justify;
	}
`;

export const ButtonsContainer = styled.div`
	width: 100%;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Reqstart = styled.span`
	font-size: 12px;
	color: #ffb222;
`;

export const ConsentsNoticeFont = styled.p`
	margin-bottom: 10px;
	font-size: 13px;
	color: #5a5a5a;
	margin-left: 25px;
	span {
		color: #ffb222;
	}
`;

export const CheckAllContainer = styled.div`
	margin: 4px 20px 24px;
	display: flex;
	align-items: center;
	p {
		margin: 0;
		user-select: none;
	}
`;
